import {cardCategories} from "../components/CardPicker";
import {Card, CardCategory} from "../components/CardPicker/cardCategories";

const emptyCards: Card[] = [];

export const getCards = (
    cardTypes: string[],
    defaultCardType?: string,
): {cards: Card[]; cardCategories: CardCategory[]} => {
    let cardCategoriesToReturn = cardCategories.filter((cardCategory) =>
        cardTypes.includes(cardCategory.cardType),
    );
    if (defaultCardType) {
        const defaultCardTypeIndex = cardCategoriesToReturn.findIndex(
            (c) => c.cardType === defaultCardType,
        );
        cardCategoriesToReturn = [
            cardCategoriesToReturn[defaultCardTypeIndex],
            ...cardCategoriesToReturn.slice(0, defaultCardTypeIndex),
            ...cardCategoriesToReturn.slice(defaultCardTypeIndex + 1),
        ];
    }

    const cardsToReturn = cardCategoriesToReturn.reduce((acc, category) => {
        return [...acc, ...category.cards];
    }, emptyCards);

    return {cards: cardsToReturn, cardCategories: cardCategoriesToReturn};
};
